const MEDIA_CONTAINER_DOUBLE_CLICK_INTERVAL = 200;
const MEDIA_CONTAINER_IMAGE_DEFAULT_SCALE = 1;
const MEDIA_CONTAINER_MIN_SWAP_DISTANCE = 100;
const MEDIA_CONTAINER_ZOOM_SCALE = 0.7;
const MEDIA_CONTAINER_PRINT_PAGE_STYLE = `
@page {
  size: auto;
  margin: 0;
}

@media print {
  img {
    width: min-content;
    height: min-content;
    max-width: 100%;
    max-height: 100%;
  }
`;
var MediaContainerMode;
(function (MediaContainerMode) {
    MediaContainerMode["COMPARISON"] = "comparison";
    MediaContainerMode["DEFAULT"] = "default";
})(MediaContainerMode || (MediaContainerMode = {}));
var MediaContainerSwapImageStep;
(function (MediaContainerSwapImageStep) {
    MediaContainerSwapImageStep[MediaContainerSwapImageStep["NEXT"] = 1] = "NEXT";
    MediaContainerSwapImageStep[MediaContainerSwapImageStep["PREVIOUS"] = -1] = "PREVIOUS";
})(MediaContainerSwapImageStep || (MediaContainerSwapImageStep = {}));
var MediaContainerZoomMode;
(function (MediaContainerZoomMode) {
    MediaContainerZoomMode["RESET"] = "reset";
    MediaContainerZoomMode["ZOOM_IN"] = "zoomIn";
    MediaContainerZoomMode["ZOOM_OUT"] = "zoomOut";
})(MediaContainerZoomMode || (MediaContainerZoomMode = {}));
export { MEDIA_CONTAINER_DOUBLE_CLICK_INTERVAL, MEDIA_CONTAINER_IMAGE_DEFAULT_SCALE, MEDIA_CONTAINER_MIN_SWAP_DISTANCE, MEDIA_CONTAINER_PRINT_PAGE_STYLE, MEDIA_CONTAINER_ZOOM_SCALE, MediaContainerMode, MediaContainerSwapImageStep, MediaContainerZoomMode, };
//# sourceMappingURL=media-container-constants.js.map